import { render } from "./ActiveNewPasswordPage.vue?vue&type=template&id=f5a9f554&ts=true"
import script from "./ActiveNewPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ActiveNewPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__